import React from "react";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";
import Download from "../../assets/download.svg";


const Transactions = () => {
  const columns = [
    {
      header: "Transaction No",
      accessor: "txnNo",
      width: 20,
    },
    {
      header: "Ref Claim No",
      accessor: "claimNo",
      width: 20,
    },
    {
      header: "Date and Time",
      accessor: "date",
      width: 20,
    },
    {
      header: "Transaction Type",
      accessor: "txnType",
      width: 20,
    },
    {
      header: "Ampunt",
      accessor: "amount",
      width: 20,
      cell: (row) => {
        return (
          <div className="w100 flex-between mr1">
            <span>{row.amount}</span>
            <span>
              <img src={Download} alt="download" width={15} />
            </span>
          </div>
        );
      },
    },
  ];

  const data = [
    {
      txnNo: "0110001036",
      claimNo: "0110001036",
      amount: "234",
      txnType: "Credit",
      date: "9 Sep' 20",
      status: "Pending",
    },
    {
      txnNo: "0110001036",
      claimNo: "0110001036",
      amount: "234",
      txnType: "Credit",
      date: "9 Sep' 20",
      status: "Pending",
    },
    {
      txnNo: "0110001036",
      claimNo: "0110001036",
      amount: "234",
      txnType: "Credit",
      date: "9 Sep' 20",
      status: "Pending",
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Credit Note"}
          showGrid={false}
          searchPlaceholder={"Search by order id..."}
          selectBox={true}
          options={[
            { label: "All Transaction", value: "all" },
            { label: "Pending Transaction", value: "pending" },
            { label: "Completed Transaction", value: "completed" },
          ]}
          defaultValue={"all"}
        >
          <Table columns={columns} data={data} action={false} actionWidth={8} />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Transactions;
